const config = {
  // apiUrl: "https://backend.aprovatotal.com.br",
  apiUrl: (process?.env?.REACT_APP_API_URL || "").replace('"', ""),
  env: "production",
};

export default config;
